import React from 'react';
import { CAMPAIGN_IMAGE_PATH } from 'constants/appConfig';
import {
    CampaignLinkContainer,
    TextContentBlock,
    CampaignTeaser,
    CampaignImage,
    Rules,
} from './styled';
import { useContainerWidth } from '../../../contexts/ContainerWidthContext';

const ViewCampaignListItem = ({ campaign }) => {
    const contentWidth = useContainerWidth();

    return (
        <CampaignLinkContainer to={`/kampagner/${campaign.seo_url}`}>
            {campaign.image && (
                <CampaignImage
                    src={CAMPAIGN_IMAGE_PATH + campaign.image}
                    alt={campaign.title}
                    width="100%"
                    $contentWidth={contentWidth}
                />
            )}
            <TextContentBlock>
                <h3>{campaign.title}</h3>
                {campaign.teaser && (
                    <CampaignTeaser
                        dangerouslySetInnerHTML={{
                            __html: campaign.teaser,
                        }}
                    />
                )}
                {campaign.rules && (
                    <Rules
                        dangerouslySetInnerHTML={{ __html: campaign.rules }}
                    />
                )}
            </TextContentBlock>
        </CampaignLinkContainer>
    );
};

export default ViewCampaignListItem;
